import { useContext, useState } from "react"
import { Box, Divider } from "@mui/material"
import { APIError } from "../../../../app/appTypes"
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { impossible } from "../../../../app/Utils"
import { showError } from "../../../notifications/notificationsSlice"
import { DocumentSectionHeader } from "../../components/DocumentSectionHeader"
import { SectionDeleteContext } from "../../DocumentContent"
import { updateDocSection } from "../../documentsApi"
import { isDocEditable, sectionSelectors, selectDocument } from "../../documentSlice"
import { DocumentSectionDeleteDialog } from "../../utils/DeleteSectionDialog"
import { RiskAnalysisSummarySectionView } from "./RiskAnalysisSummarySectionView"

export const RiskAnalysisSummarySectionWrapper = (props: { sectionId: string }) => {
    const { sectionId } = props
    const dispatch = useAppDispatch()
    const deleteSection = useContext(SectionDeleteContext)
    const section = useAppSelector(state => sectionSelectors.selectById(state, sectionId)) ?? impossible()
    const { header } = useAppSelector(selectDocument)?.doc ?? impossible()
    const isEditable = useAppSelector(isDocEditable)
    const { numeration } = section

    const [error, setError] = useState<APIError | null>(null)
    const [del, setDel] = useState(false)
    const [deleting, setDeleting] = useState(false)

    const handleApprove = async (newName: string) => {
        if (!newName) {
            return
        }

        try {
            await dispatch(updateDocSection({ ...section, name: newName })).unwrap()
        } catch (err) {
            setError(err as APIError)
        }
    }

    const handleDeleteClick = () => setDel(true)

    const handleConfirmDeleteClick = async () => {
        try {
            setDeleting(true)
            deleteSection(sectionId)
        } catch {
            dispatch(showError("error"))
        } finally {
            setDeleting(false)
        }
    }

    const handleCancelDelClick = () => setDel(false)

    return <>
        <DocumentSectionHeader
            numeration={numeration}
            name={section.name}
            isEditable={isEditable}
            error={error}
            onSaveName={handleApprove}
            onDeleteClick={handleDeleteClick}
        />

        {del && (
            <DocumentSectionDeleteDialog
                deleting={deleting}
                hasSubSections={section.subSectionsIds.length > 0}
                onConfirm={handleConfirmDeleteClick}
                onCancel={handleCancelDelClick}
            />
        )}


        <Box sx={{ mt: 2 }}>
            <RiskAnalysisSummarySectionView documentId={Number(header.id)} />
        </Box>
    </>
}